import type { FaireProductEntity } from "../../entity_types/product";

export const p_fsfsk74vv6: FaireProductEntity = {
  token: "p_fsfsk74vv6",
  type: "product",
  name: "Naked Seaweed Snack-Mini",
  brandToken: "b_31af10wylw",
  brandName: "JAYONE",
  imageUrl:
    "https://cdn.faire.com/fastly/2163f6c74d023e97e83af0713ca1951be849bb07408837d098d9dd53ba129757.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.05,
  description:
    "Mini naked seaweed snack — lightly roasted, unseasoned seaweed in tiny single-serve packs for children's lunchboxes and light snacking. 4-pack, imported from Korea.",
  tags: [],
  msrpDollars: 1.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:18.986Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
